import Cookies from 'js-cookie';

document.arrive('#listings-tab', function() {
  $(this).find('.nav-link').on('click', function() {
    const dataType = $(this).data('type');
    Cookies.set('last_listing_tab', dataType, { expires: 365 });
  });
});
